<div
  class="zuper-shimmer"
  [ngClass]="{  }"
  [ngStyle]="{
    width: width,
    height: shimmerHeight,
    borderRadius: shimmerBorderRadius
  }"
  [ngClass]="{ rtl: direction === 'rtl', 'connect-theme': useConnectTheme }"
></div>
